import ApiService from '../api.services';

const AttendanceService = {
  list: async function() {
    try {
      const response = await ApiService.get('/api/attendance');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  get: async function(id) {
    try {
      const response = await ApiService.get(`/api/attendance/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  add: async function(form) {
    try {
      const data = {
        attendance: form,
      };
      const res = await ApiService.post('/api/attendance', data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  update: async function(id, form) {
    const data = {
      attendance: form,
    };
    try {
      const response = await ApiService.put(`/api/attendance/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  delete: async function(id) {
    try {
      const response = await ApiService.delete(`/api/attendance/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default AttendanceService;

export { AttendanceService };
